module.exports = __webpack_public_path__ + "static/media/btn_nose.b23b78b4.png";